
import Vue from 'vue';
import PageHeader from '@/components/layout/PageHeader.vue';

import UTILS from '@/store/modules/UtilityModule';
import MISC_DATA from '@/store/modules/MiscDataModule';
import { GACustomEvent } from '~/types/misc_data';
import { formatPhone } from '@/_helpers/misc_helper';

export default Vue.extend({
	name: 'FAQ',

	components: { PageHeader },

	async asyncData(context) {
		const domain = context.$getDomain();
		let currentLanguage = '';
		const lang_per_domain = {
			at: 'de-AT',
			de: 'de-DE',
			cz: 'cs-CZ',
			hu: 'hu-HU',
			sk: 'sk-SK'
		} as any;

		if (process.client) {
			if (typeof sessionStorage !== 'undefined') {
				const key = 'lang';
				const langData = sessionStorage.getItem(key) !== null;
				if (langData) {
					const getLang = sessionStorage.getItem(key);
					if (getLang) {
						currentLanguage = getLang.slice(0, 2);
					}
				}
			}
		}

		const jsonld = {
			'@context': 'https://schema.org/',
			'@type': 'FAQPage',
			mainEntity: [] as any
		};

		const res = await context.store.dispatch('GET_FAQ_LIST', {
			domain: domain,
			lang: currentLanguage !== '' ? currentLanguage : lang_per_domain[domain].split('-')[0]
		});
		if (res) {
			for (const i in res) {
				let content = '';

				// Strip html from the content
				if (res[i].content) {
					content = res[i].content
						.replace(/<style[^>]*>.*<\/style>/gm, '')
						// Remove script tags and content
						.replace(/<script[^>]*>.*<\/script>/gm, '')
						// Remove all opening, closing and orphan HTML tags
						.replace(/<[^>]+>/gm, '')
						// Remove leading spaces and repeated CR/LF
						.replace(/([\r\n]+ +)+/gm, '');
				}

				jsonld.mainEntity.push({
					'@type': 'Question',
					name: res[i].title,
					acceptedAnswer: {
						'@type': 'Answer',
						text: content
					}
				});
			}
		}

		await context.store.dispatch('STORE_JSON_LD', jsonld); // will be check by default.vue to set this JSONLD instead of default one.
		// Don't see how to do this better for now. If sets in head() of this component - it will be overwritten by default.vue's head() (which is dumb).
		// Also this is stored on server side to be ready - could be in a middleware (although works the same), this was initially done here to use it directly in head()
		// As a note about asyncData: We can also return { jsonld } here which will be assigned to this.jsonld in the data() (it has to be already declared though)
	},

	data() {
		return {
			searchtext: '',
			expandedPanel: null
		};
	},

	computed: {
		UTILS: () => UTILS,
		MISC_DATA: () => MISC_DATA,

		list(): any {
			return this.MISC_DATA.faq;
		},

		availableContent() {
			return process.client;
		},

		entries(): any {
			if (this.searchtext === null) {
				return this.list;
			}

			const search = this.searchtext.trim().toLowerCase().replaceAll(/\s/gi, '');

			if (search.length < 1) {
				return this.list;
			}

			return this.list.filter((el: any) => {
				// check title
				const stitle = el.title.toLowerCase().trim().replaceAll(/\s/gi, '');
				if (stitle.includes(search)) {
					return true;
				}

				// strip html chars
				const doc = new DOMParser().parseFromString(el.content, 'text/html');
				let scontent = doc.body.textContent || '';
				scontent = scontent.toLowerCase().trim().replaceAll(/\s/gi, '');

				// check content
				if (scontent.includes(search)) {
					return true;
				}

				return false;
			});
		},

		currentLanguage(): string {
			return this.$i18n.locale;
		}
	},

	watch: {
		currentLanguage() {
			this.requestFAQ(this.currentLanguage);
		}
	},

	async destroyed() {
		await this.MISC_DATA.STORE_JSON_LD(null); // removes the component's JSONLD on destroy so that default.vue can set the default one again...
		// this is probably not necessary anymore - Default is only using the stored jsonld on FAQ and LP routes.
	},

	methods: {
		async requestFAQ(lang: string) {
			const bu = this.$getDomain();
			lang = lang.substring(0, 2);

			await this.MISC_DATA.GET_FAQ_LIST({ domain: bu, lang: lang });
		},
		formatPhone(input: string): string {
			return formatPhone(input);
		},

		phoneClicked() {
			this.$tracking.custom_event(GACustomEvent.phone_on_faq_page);
		}
	}
});
